import React from "react";
import "./index.css";
import Team_Image_01 from '../../../assets/Images/OurTeam/selva.JPEG';
import Team_Image_02 from '../../../assets/Images/OurTeam/thaslim1.jpg';
import Team_Image_03 from '../../../assets/Images/OurTeam/praveen.jpg';
import Team_Image_04 from '../../../assets/Images/OurTeam/bharathi.jpg';
import Team_Image_05 from '../../../assets/Images/OurTeam/hasim1.jpg';
import Team_Image_06 from '../../../assets/Images/OurTeam/sakthi.jpg';
import Team_Image_07 from '../../../assets/Images/OurTeam/no-1.jpeg';

function Card_Team() {
  return (
    <>
      <div class="team">
        <div class="default-section-title default-section-title-middle">
          <h6>OUR TEAM</h6>
          <h3>Meet Our Professional Experienced Team</h3>
        </div>
        <div class="section-content">
          <div class="row mb-5">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                  <img src={Team_Image_01} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Selva Ganesh</a>
                  </h4>
                  <p>Frond-End Developer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_02} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Mohamed Thaslim</a>
                  </h4>
                  <p>Back-End Developer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_03} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Boss Praveen</a>
                  </h4>
                  <p>Frond-End Developer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_06} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Sakthi Vel</a>
                  </h4>
                  <p>Mobile App Developer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_04} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Bharathi Kannan</a>
                  </h4>
                  <p>Frond-End Developer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_05} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Mohamed Haashim</a>
                  </h4>
                  <p>Manager</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_07} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Siva</a>
                  </h4>
                  <p>Frond-End Developer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <div class="team-card">
                <div class="team-card-img">
                <img src={Team_Image_07} alt="image" />
                </div>
                <div class="team-card-text">
                  <h4>
                    <a href="team.html" className="team-card-name-header">Selvam</a>
                  </h4>
                  <p>Engineer</p>
                  <div class="team-social-icons">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/" target="_blank">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/" target="_blank">
                          <i class="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://twitter.com/" target="_blank">
                          <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank">
                          <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card_Team;
